<template>
<div class="chapter">
<div class="inner_page">
<h1 class="section">TABLE OF CONTENTS</h1>
<p class="crt"><span class="hlink" href="#/text/tp" title="Link target outside of Sample">Title Page</span></p>
<p class="crt"><span class="hlink" href="#/text/cop" title="Link target outside of Sample">Copyright</span></p>
<p class="crt"><a class="hlink" href="#/text/ded">Dedication</a></p>
<p class="crt1"><a class="hlink" href="#/text/p01"><strong>Part One</strong></a></p>
<p class="crt"><a class="hlink" href="#/text/c01">Chapter One</a></p>
<p class="crt"><a class="hlink" href="#/text/c02">Chapter Two</a></p>
<p class="crt"><a class="hlink" href="#/text/c03">Chapter Three</a></p>
<p class="crt"><span class="hlink" href="#/text/c04" title="Link target outside of Sample">Chapter Four</span></p>
<p class="crt"><span class="hlink" href="#/text/c05" title="Link target outside of Sample">Chapter Five</span></p>
<p class="crt"><span class="hlink" href="#/text/c06" title="Link target outside of Sample">Chapter Six</span></p>
<p class="crt"><span class="hlink" href="#/text/c07" title="Link target outside of Sample">Chapter Seven</span></p>
<p class="crt"><span class="hlink" href="#/text/c08" title="Link target outside of Sample">Chapter Eight</span></p>
<p class="crt"><span class="hlink" href="#/text/c09" title="Link target outside of Sample">Chapter Nine</span></p>
<p class="crt"><span class="hlink" href="#/text/c10" title="Link target outside of Sample">Chapter Ten</span></p>
<p class="crt"><span class="hlink" href="#/text/c11" title="Link target outside of Sample">Chapter Eleven</span></p>
<p class="crt1"><span class="hlink" href="#/text/p02" title="Link target outside of Sample"><strong>Part Two</strong></span></p>
<p class="crt"><span class="hlink" href="#/text/c12" title="Link target outside of Sample">Chapter Twelve</span></p>
<p class="crt"><span class="hlink" href="#/text/c13" title="Link target outside of Sample">Chapter Thirteen</span></p>
<p class="crt"><span class="hlink" href="#/text/c14" title="Link target outside of Sample">Chapter Fourteen</span></p>
<p class="crt"><span class="hlink" href="#/text/c15" title="Link target outside of Sample">Chapter Fifteen</span></p>
<p class="crt"><span class="hlink" href="#/text/c16" title="Link target outside of Sample">Chapter Sixteen</span></p>
<p class="crt"><span class="hlink" href="#/text/c17" title="Link target outside of Sample">Chapter Seventeen</span></p>
<p class="crt"><span class="hlink" href="#/text/c18" title="Link target outside of Sample">Chapter Eighteen</span></p>
<p class="crt"><span class="hlink" href="#/text/c19" title="Link target outside of Sample">Chapter Nineteen</span></p>
<p class="crt"><span class="hlink" href="#/text/c20" title="Link target outside of Sample">Chapter Twenty</span></p>
<p class="crt"><span class="hlink" href="#/text/c21" title="Link target outside of Sample">Chapter Twenty-One</span></p>
<p class="crt"><span class="hlink" href="#/text/c22" title="Link target outside of Sample">Chapter Twenty-Two</span></p>
<p class="crt"><span class="hlink" href="#/text/c23" title="Link target outside of Sample">Chapter Twenty-Three</span></p>
<p class="crt"><span class="hlink" href="#/text/c24" title="Link target outside of Sample">Chapter Twenty-Four</span></p>
<p class="crt"><span class="hlink" href="#/text/c25" title="Link target outside of Sample">Chapter Twenty-Five</span></p>
<p class="crt1"><span class="hlink" href="#/text/epi" title="Link target outside of Sample">Epilogue</span></p>
<p class="crt1"><span class="hlink" href="#/text/glossary" title="Link target outside of Sample">Glossary</span></p>
<p class="crt"><span class="hlink" href="#/text/ata" title="Link target outside of Sample">About the Author</span></p>
<p class="crt"><span class="hlink" href="#/text/alsoby" title="Link target outside of Sample">Other Books by Marie Brennan</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?2daa8226